export default __webpack_public_path__ + "static/media/mylogo.0b4ac474.png";